module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJf7J207Ja0XzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI1LjUxIDkuMDQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iaWNvbiI+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMSIgeTE9IjQuNTIiIHgyPSIyNC41MSIgeTI9IjQuNTIiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjIwLjk5IDEgMjQuNTEgNC41MiAyMC45OSA4LjA0Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_right.svg
// module id = DB3Y
// module chunks = 1